import Swal from "sweetalert2";

const toast = Swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
});

export const showSuccessToast = (message) => {
    if (!message) return;
    toast.fire({ icon: "success", title: message });
};

export const showErrorToast = (message) => {
    if (!message) return;
    toast.fire({ icon: "error", title: message });
};
